import { MILLISECONDS_IN_A_DAY, REFRESH_TOKEN_EXPIRY_STORAGE_KEY } from '../constants';

export default function updateRefreshTokenExpiry() {
  const thirtyDaysFromNow = Date.now() + 30 * MILLISECONDS_IN_A_DAY;
  localStorage.setItem(REFRESH_TOKEN_EXPIRY_STORAGE_KEY, thirtyDaysFromNow.toString());
}
